var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { Image } from '../../Image';
import { withSkeleton } from '../../Skeleton';
import { ComponentWrapper, OwnSkeleton } from '../styles';
var ImageSkeleton = function (_a) {
    var _b = _a.animation, animation = _b === void 0 ? true : _b;
    return (React.createElement(OwnSkeleton, { animation: animation, width: "50px", height: "50px" }));
};
var BrandImageWrapper = styled(ComponentWrapper)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  justify-content: center;\n\n  > img {\n    max-height: 50px;\n    width: auto;\n  }\n"], ["\n  width: 100%;\n  display: flex;\n  justify-content: center;\n\n  > img {\n    max-height: 50px;\n    width: auto;\n  }\n"])));
var BrandImage = function (_a) {
    var brand = _a.brand;
    return brand && brand.image ? (React.createElement(BrandImageWrapper, { "data-testid": "brandImage", marginBottom: "0.3rem" },
        React.createElement(Image, { alt: brand.name, src: brand.image, title: brand.name, loadingComponent: function () { return React.createElement(ImageSkeleton, null); }, keepPrevLoadedImage: true, fallback: function () { return React.createElement(ImageSkeleton, { animation: false }); } }))) : null;
};
export default withSkeleton(BrandImage, function () { return React.createElement(ImageSkeleton, null); });
var templateObject_1;
//# sourceMappingURL=index.js.map